/* ==========================================================================
   NaturoTheke — Produktempfehlungen: Option waehlen und direkt hinzufuegen.

   Bewusst ohne stilles Fehlerschlucken: schlaegt das Nachrendern des Drawers
   fehl, wird neu geladen, statt dass der Kunde einen scheinbar wirkungslosen
   Klick sieht. Der Artikel liegt in dem Fall bereits im Warenkorb.
   ========================================================================== */

(function () {
  'use strict';

  function getCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Liefert das Feld mit der gewaehlten Varianten-ID.
  //
  // Reihenfolge zaehlt: Ein <select> ist weder ":checked" noch ein
  // verstecktes Feld — wurde es hier vergessen, lieferte die Funktion null
  // und der Button tat bei jedem Produkt mit Varianten stillschweigend
  // gar nichts.
  function selectedInput(card) {
    return (
      card.querySelector('select.naturo-upsell-card__option-input') ||
      card.querySelector('.naturo-upsell-card__option-input:checked') ||
      card.querySelector('input[type="hidden"].naturo-upsell-card__option-input')
    );
  }

  function showError(card, message) {
    var wrapper = card.closest('[data-naturo-upsell]');
    var target = wrapper && wrapper.querySelector('[data-naturo-upsell-error]');
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function clearError(card) {
    var wrapper = card.closest('[data-naturo-upsell]');
    var target = wrapper && wrapper.querySelector('[data-naturo-upsell-error]');
    if (!target) return;
    target.textContent = '';
    target.hidden = true;
  }

  function setBusy(button, busy) {
    var label = button.querySelector('[data-naturo-upsell-label]');
    if (busy) {
      button.setAttribute('aria-disabled', 'true');
      button.dataset.naturoLabel = label ? label.textContent : '';
      if (label) label.textContent = '…';
    } else {
      button.removeAttribute('aria-disabled');
      if (label && button.dataset.naturoLabel) label.textContent = button.dataset.naturoLabel;
    }
  }

  // Kurze Rueckmeldung, danach zurueck in den Normalzustand. Der Button muss
  // wieder klickbar sein — man kann dasselbe Produkt auch zweimal wollen.
  function confirmAdded(button) {
    if (!button.isConnected) return;

    var label = button.querySelector('[data-naturo-upsell-label]');
    var original = button.dataset.naturoLabel;

    button.removeAttribute('aria-disabled');
    button.classList.add('is-added');
    if (label) label.textContent = window.naturoAddedLabel || 'Hinzugefügt';

    setTimeout(function () {
      if (!button.isConnected) return;
      button.classList.remove('is-added');
      if (label && original) label.textContent = original;
    }, 1800);
  }

  function addToCart(button) {
    var card = button.closest('[data-naturo-upsell-card]');
    if (!card) return;

    var input = selectedInput(card);
    if (!input || !input.value) {
      // Nie stumm abbrechen — genau so blieb ein Fehler lange unentdeckt.
      console.error('[naturo-upsell] Keine Variante ermittelbar', card);
      showError(card, 'Bitte wähle zuerst eine Variante.');
      return;
    }

    clearError(card);
    setBusy(button, true);

    var cart = getCartElement();
    var canRender =
      !!cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';

    var body = new FormData();
    body.append('id', input.value);
    body.append('quantity', 1);

    if (canRender) {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsed) {
        // Shopify liefert bei Fehlern (z. B. ausverkauft) ein Objekt mit "status".
        if (parsed.status) {
          setBusy(button, false);
          showError(card, parsed.description || parsed.message);
          return;
        }

        if (!canRender) {
          window.location.reload();
          return;
        }

        // War der Warenkorb beim Seitenaufbau leer, traegt <cart-drawer>
        // noch die Klasse "is-empty". Dawn entfernt sie in product-form.js
        // nach dem Hinzufuegen; bleibt sie stehen, sucht der Drawer beim
        // Oeffnen den Leer-Zustand-Container, findet null und Dawns
        // trapFocus() wirft (global.js: getFocusableElements).
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

        try {
          cart.renderContents(parsed);
        } catch (error) {
          // Der Artikel liegt bereits im Warenkorb — nur die Anzeige haengt.
          console.error('[naturo-upsell] Drawer konnte nicht neu gerendert werden:', error);
          window.location.reload();
          return;
        }

        // WICHTIG: Karten ausserhalb des Drawers (Kaufbox auf der
        // Produktseite) werden von renderContents NICHT ersetzt. Ohne
        // dieses Zuruecksetzen blieb der Button dort dauerhaft im
        // Lade-Zustand ("…") und war nicht mehr klickbar.
        confirmAdded(button);
      })
      .catch(function (error) {
        console.error('[naturo-upsell] Hinzufuegen fehlgeschlagen:', error);
        setBusy(button, false);
        showError(card, 'Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      });
  }

  // Delegiert, damit alles auch nach dem Neurendern des Drawers weiter wirkt.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-naturo-upsell-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;
    addToCart(button);
  });

  // Preis an die gewaehlte Option anpassen (Pillen und Auswahlfeld).
  document.addEventListener('change', function (event) {
    var input = event.target.closest('.naturo-upsell-card__option-input');
    if (!input) return;

    var price = input.dataset.price;
    if (input.tagName === 'SELECT') {
      var option = input.options[input.selectedIndex];
      price = option && option.dataset.price;
    }
    if (!price) return;

    var card = input.closest('[data-naturo-upsell-card]');
    var target = card && card.querySelector('[data-naturo-upsell-price]');
    if (target) target.textContent = price;
  });

  /* ------------------------------------------------------------------
     Horizontaler Slider im Warenkorb.

     Die Pfeile erscheinen nur, wenn wirklich mehr Karten da sind, als
     hineinpassen — sonst sind sie nur Ballast. Delegiert und ueber
     MutationObserver neu verdrahtet, weil der Drawer nach jedem
     Warenkorb-Update komplett neu gerendert wird.
     ------------------------------------------------------------------ */

  function syncSlider(list) {
    var track = list.querySelector('[data-naturo-upsell-track]');
    var nav = list.querySelector('[data-naturo-upsell-nav]');
    if (!track || !nav) return;

    var max = track.scrollWidth - track.clientWidth;

    // Pfeile nur zeigen, wenn es wirklich mehr als eine Karte gibt.
    nav.hidden = max <= 4;

    var prev = nav.querySelector('[data-naturo-upsell-prev]');
    var next = nav.querySelector('[data-naturo-upsell-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  function syncAllSliders() {
    document.querySelectorAll('.naturo-upsell-list--slider').forEach(syncSlider);
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-naturo-upsell-prev], [data-naturo-upsell-next]');
    if (!arrow) return;
    event.preventDefault();

    var list = arrow.closest('.naturo-upsell-list');
    var track = list && list.querySelector('[data-naturo-upsell-track]');
    if (!track) return;

    var card = track.querySelector('[data-naturo-upsell-card]');
    var step = card ? card.offsetWidth + 10 : track.clientWidth;
    track.scrollBy({ left: arrow.hasAttribute('data-naturo-upsell-prev') ? -step : step, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target.closest && event.target.closest('[data-naturo-upsell-track]');
      if (!track) return;
      var list = track.closest('.naturo-upsell-list');
      if (list) syncSlider(list);
    },
    true
  );

  window.addEventListener('resize', syncAllSliders);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllSliders);
  } else {
    syncAllSliders();
  }

  // Nach dem Neurendern des Drawers erneut vermessen.
  //
  // Bewusst nur der Warenkorb-Drawer und entprellt: ein Observer auf dem
  // ganzen Dokument feuerte bei jeder DOM-Aenderung der Seite (auch von
  // Apps) und mass jedes Mal alle Slider neu.
  var syncTimer = null;
  function syncSoon() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncAllSliders, 120);
  }

  var drawer = document.getElementById('CartDrawer');
  if (drawer) {
    new MutationObserver(syncSoon).observe(drawer, { childList: true, subtree: true });
  }
})();
